<template>
  <div v-if="language.includes('es')" class="container">
    <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
    <h1>Buscar</h1>
    <input id="busqueda" v-on:keyup="buscar" class="barraDeBusqueda" placeholder="¿Qué relato estás buscando?" type="text" autocomplete="off"/>
    <div v-if="relatosValidos != ''" class="resultados">
      <div v-if="relatosValidos != null" v-for="(relato, numero) in relatosValidos" :key="relato.id" class="opcion">
        <div v-if="relatosDisponibles.includes(relato[0])">
          <router-link :to="{ name: 'relatos', params: { relato: relato[0], categoria: relato[1] } }">
            <h3>{{ ++numero }}. {{ relato[0] }} - {{ relato[1].charAt(0).toUpperCase() + relato[1].slice(1) }}</h3>
          </router-link>
        </div>
        <div v-else class="locked" @click="mostrarPopup">
          <h3>
            {{ ++numero }}. {{ relato[0] }} - {{ relato[1].charAt(0).toUpperCase() + relato[1].slice(1) }}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
            </svg>
          </h3>
        </div>
      </div>
      <h2 v-else> No se encontraron resultados </h2>
    </div>
  </div>

  <div v-else class="container">
    <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
    <h1>Search</h1>
    <input id="busqueda" v-on:keyup="buscar" class="barraDeBusqueda" placeholder="Which folktale are you looking for?" type="text" autocomplete="off"/>
    <div v-if="relatosValidos != ''" class="resultados">
      <div v-if="relatosValidos != null" v-for="(relato, numero) in relatosValidos" :key="relato.id" class="opcion">
        <div v-if="relatosDisponibles.includes(relato[0])">
          <router-link :to="{ name: 'relatos', params: { relato: relato[0], categoria: relato[1] }}">
            <h3 v-if="relato[1] === 'niños'">{{ ++numero }}. {{ relato[0] }} - Children </h3>
            <h3 v-else-if="relato[1] === 'adultos'">{{ ++numero }}. {{ relato[0] }} - Adults </h3>
            <h3 v-else>{{ ++numero }}. {{ relato[0] }} - Grandparents </h3>
          </router-link>
        </div>
        <div v-else class="locked" @click="mostrarPopup">
          <h3 v-if="relato[1] === 'niños'">
            {{ ++numero }}. {{ relato[0] }} - Children 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
            </svg>
          </h3>
          <h3 v-else-if="relato[1] === 'adultos'">
            {{ ++numero }}. {{ relato[0] }} - Adults 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
            </svg>
          </h3>
          <h3 v-else>
            {{ ++numero }}. {{ relato[0] }} - Grandparents 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
            </svg>
          </h3>
        </div>
      </div>
      <h2 v-else> No results found </h2>
    </div>
  </div>

  <Popup v-if="TogglePopup" v-on:metodo="cerrarPopup" :texto="textoPopup" />

</template>

<script>
import { db } from '@/main.js'
import { onSnapshot, collection, query, addDoc } from 'firebase/firestore'
import Popup from '@/components/Popup.vue'
import { getAuth } from 'firebase/auth'

export default {
  components: {
    Popup
  },
  data () {
    return {
      listaDeRelatos: {
        niños: [],
        adultos: [],
        abuelos: []
      },
      relatosValidos: '',
      language: navigator.language,
      TogglePopup: false,
      textoPopup: '',
      relatosDisponibles: ["Amelia y Rocky", "Arremedar al Silbón", "Bus y Perros"] // Lista de relatos disponibles en esta version
    }
  },
  mounted () {
    // Cambiar titulo de la ventana
    if (this.language.includes('es')) {
      document.title = 'Buscar'
    } else {
      document.title = 'Search'
    }

    // Consultar todos los relatos de cada una de las categorias
    for (let categoria in this.listaDeRelatos) {      
      let colleccionDeRelatos = collection(db, categoria.charAt(0).toUpperCase() + categoria.slice(1))
      let consulta = query(colleccionDeRelatos)
      onSnapshot(consulta, (queryData) => {
        queryData.forEach((doc) => {
          this.listaDeRelatos[categoria].push(doc.data())
        })
      })
    }
  },
  beforeUnmount() {
    // Guardar la busqueda realizada
    this.guardarBusqueda()
  },
  methods: {
    buscar () {
      // Obtener el input del usuario
      let entradaDeUsuario = document.getElementById('busqueda').value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

      // Revisar que la entrada del usuario no este vacia
      if (entradaDeUsuario == '') {
        this.relatosValidos = null
        return
      }

      // Declarar lista de relatos a mostrar
      let relatosAMostrar = [];

      // Revisar todos los titulos que coinciden con el input del usuario
      for (let categoria in this.listaDeRelatos) {
        for (let relato in this.listaDeRelatos[categoria]) {
          let titulo = this.listaDeRelatos[categoria][relato].Titulo.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

          if (titulo.includes(entradaDeUsuario)) {
            let relatoCategoria = [ this.listaDeRelatos[categoria][relato].Titulo, categoria ]
            relatosAMostrar.push(relatoCategoria)
          }
        }
      }

      // Revisar si hay relatos que coninciden con la busqueda
      if (relatosAMostrar.length == 0) {
        this.relatosValidos = null
        return
      }

      // Actualizar la variable para mostrar en el template
      this.relatosValidos = relatosAMostrar;
    },

    // Funciones del popup
    mostrarPopup() {
      if (this.language.includes('es')) {
        this.textoPopup = 'No disponible en esta versión, <a href="mailto:support@funifelt.com?subject=Solicitud%20de%20acceso%20total%20a%20relatos%20culturales" target="_blank">contáctanos</a\> para obtener más información'
      } else {
        this.textoPopup = 'Not available in this version, <a href="mailto:support@funifelt.com?subject=Request%20full%20access%20to%20spanish%20folktales" target="_blank">contact us</a\> for more information'
      }
      this.TogglePopup = true
    },
    cerrarPopup () {
      this.TogglePopup = false
    },

    // Funcion para guardar la busqueda realizada en la base de datos
    async guardarBusqueda() {
      // Obtener la busqueda realizada
      let busqueda = document.getElementById('busqueda').value

      // No guardar busqueda si esta vacia
      if (busqueda == '') {
        return
      }

      // Crear un documento en la coleccion de busquedas con los datos de la busqueda
      let date = new Date()
      const docRef = await addDoc(collection(db, "Busquedas"), {
        busqueda: busqueda,
        userID: getAuth().currentUser.uid,
        fecha: date
      })
      console.log(busqueda + ' guardada con el ID: ' + docRef.id)
    }
  }
}
</script>

<style src="@/assets/css/busqueda.css" scoped></style>
